import React from "react";
import Footer from "./../Footer";
import { Link, withRouter } from "react-router-dom";

import { Pages, Settings } from "./Pages";

class Chapter5 extends React.Component {
  constructor(props) {
    super(props);

    this.page = Pages[6];
    this.handleTogglePopout = this.handleTogglePopout.bind(this);

    this.handlePopoutImages = this.handlePopoutImages.bind(this);
    this.popImages = [
      `${process.env.PUBLIC_URL}/images/bank-archives.jpg`,
      `${process.env.PUBLIC_URL}/images/open-house.jpg`,
      `${process.env.PUBLIC_URL}/images/ellen-blazure.jpg`
    ];
  }

  handlePopoutImages = e => {
    this.props.popoutImages(e);
  };

  handleTogglePopout = popout => {
    this.props.togglePopout(popout);
  };

  componentDidMount() {
    this.props.bgHoverState(this.page.color);
    this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

    this.props.gatherImages(this.popImages);

    document.title = `${this.page.name.replace(
      "<br />",
      ""
    )} | Peapack 100 Anniversary`;
    document.body.className = "page-inner page-chapter-5";
  }

  render() {
    return (
      <div className="page-wrapper">
        <div className="page">
          <div className="header-section wrapper">
            <div className="row">
              <div className="col-left col-md-6">
                <div className="header-content">
                  <Link
                    to="/"
                    onClick={this.props.bgHoverState}
                    className="back-button"
                  >
                    Back
                  </Link>
                  <h1 dangerouslySetInnerHTML={{ __html: this.page.name }} />
                  <div className="caption">
                    The Bank’s second headquarters building at 190 Main Street,
                    Peapack-Gladstone (Peapack-Gladstone Bank archives)
                  </div>
                </div>
              </div>
              <div className="col-right col-md-6">
                <figure className="header-thumbnail anim-up">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/thumbnail-chapter-5.jpg`}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="white-background entry-content">
            <div className="wrapper">
              <div className="row">
                <div className="col-md-8">
                  <p>
                    The Bank had just marked its twentieth anniversary milestone
                    with assets of $1,264,364 when the United States entered
                    World War II. Approximately 157 men from Peapack-Gladstone
                    joined the service, including Director Anderson Fowler, who
                    instructed horsemanship at Ft. Riley and served as a captain
                    with the First Cavalry in the Pacific, where he earned a
                    Bronze Star in the landings at Leyte Gulf. The Bank
                    persevered through the war years but faced a major change
                    with the death of President Francis K. Stevens in 1945. He
                    was succeeded by Vice President G. F. Hill, a Bank founder
                    and original Board member. Mr. Hill’s comprehensive
                    knowledge of the Bank and its operations made for a seamless
                    transition and continued measured growth.
                  </p>
                </div>
                <div className="col-md-4">
                  <figure className="img abs-md">
                    <div
                      className="popout-image"
                      onClick={this.handlePopoutImages}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/bank-archives.jpg`}
                        alt=""
                      />
                    </div>
                    <figcaption>(Peapack-Gladstone Bank archives)</figcaption>
                  </figure>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <p>
                    By the mid-1950s the Bank’s assets had grown to more than $5
                    million. The original Bank building adjacent to G. F. Hill’s
                    store could no longer accommodate the growing institution.
                    On July 23, 1956, the Bank acquired a tract of land from the
                    Peapack Reformed Church at 190 Main Street in Gladstone for
                    $25,000. At a special stockholders' meeting on November 19,
                    1957, approval was given to pay a 200% stock dividend
                    (thereby increasing the outstanding shares from 2,000 to
                    6,000) and to issue 3,000 new shares. The additional capital
                    made it possible to build a completely modern banking
                    facility on the newly purchased lot. By this time, the Board
                    was composed of a new generation of community leaders,
                    including Oliver D. Filley, Jr., Ronald A. Gulik, T. Leonard
                    Hill, Sheldon F. Martin, William L. Tredway, and William
                    Turnbull. The Directors marketed the stock and agreed to
                    purchase whatever was not bought by existing or new
                    shareholders.
                  </p>
                  <p>A local newspaper reported, </p>
                  <blockquote>
                    A handsome new addition to the borough of Peapack-Gladstone
                    was unveiled to residents Saturday when the
                    Peapack-Gladstone Bank opened the doors to its new home.
                    Patrons and friends were high in praise for the cheerful,
                    roomy and bright new surroundings in which they will be
                    doing their banking from now on.
                  </blockquote>
                  <p>
                    Visitors had the opportunity to observe several innovations,
                    including a drive-in window, a night deposit facility,
                    carpeted and paneled air-conditioned offices, and a new main
                    floor vault. To commemorate the occasion, the Bank gave away
                    key chain coin holders and tin serving trays.
                  </p>
                  <p>
                    The Bank continued to move forward under the leadership of
                    G. F. Hill. He was increasingly aided by Executive Vice
                    President Alvah Alpaugh and key employee Ellen Blazure, who
                    had grown up on Main Street in Peapack. Due to her
                    experience as a bookkeeper for a Basking Ridge automobile
                    dealership, Mrs. Blazure was recruited by Mr. Alpaugh in the
                    summer of 1951 as a temporary fill-in for vacationing Bank
                    employees. Mrs. Blazure found her professional home at the
                    Bank and stayed until her retirement in 1976. During those
                    years, Mrs. Blazure rose from the bookkeeper position to
                    Senior Vice President. In 1973, she was elected to the
                    Bank’s Board of Directors, thereby becoming its first woman
                    Board member. One of the Bank’s most highly compensated
                    employees by the mid-1960s, Mrs. Blazure was a trailblazing
                    woman in New Jersey banking.
                  </p>
                </div>
                <div className="col-md-4 pt-md-5">
                  <figure className="img abs-md pt-md-5">
                    <div
                      className="popout-image"
                      onClick={this.handlePopoutImages}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/open-house.jpg`}
                        alt=""
                      />
                    </div>
                    <figcaption>
                      A full-page ad in{" "}
                      <span className="roman">The Somerset Hills Exponent</span>{" "}
                      appearing May 29, 1958 (Peapack-Gladstone Bank archives)
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <p>
                    After more than four decades with the Bank, Alvah Alpaugh
                    passed away on May 27, 1965. In recognition of his service,
                    Mr. Alpaugh was memorialized in the Board of Directors
                    meeting minutes as follows.
                  </p>
                  <blockquote>
                    Coming to us as a young man on September 18, 1921, he spent
                    his entire business life in the service of this Bank, and
                    was most instrumental in the growth of our institution for
                    more than 43 years. At the same time, during this period he
                    was active in numerous civic affairs of our community. He
                    will be long remembered for his abilities—always at the
                    service of others, his untiring energy and unswerving sense
                    of honor.
                  </blockquote>
                  <p>
                    In his 1965 year-end report, Bank President G. F. Hill
                    further commented, “Our Bank suffered a severe loss from the
                    death of Alvah M. Alpaugh, Executive Vice President, Cashier
                    and Director. . . . through his entire lifetime he
                    contributed enormously to both the Bank and the community.”
                  </p>
                  <p>
                    Mr. Alpaugh would be succeeded by a man who became the
                    Bank’s first professionally experienced banker.
                  </p>
                </div>
                <div className="col-md-4">
                  <figure className="img abs-md mt-sm--5">
                    <div className="row">
                      <div className="col-6 text-center">
                        <div
                          className="popout-image"
                          onClick={this.handlePopoutImages}
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/images/ellen-blazure.jpg`}
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="col-6 d-flex">
                        <figcaption className="align-self-center">
                          Ellen Blazure, the Bank’s first woman Board member
                          (courtesy of Fred Blazure)
                        </figcaption>
                      </div>
                    </div>
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <Footer togglePopout={this.handleTogglePopout} />
        </div>
      </div>
    );
  }
}

export default withRouter(Chapter5);
